import React from "react";
import { useTranslation } from "react-i18next";
import { QrCodeEditor } from "../features/qr-codes/Editor";
import { withRestaurantId } from "../shared/components/layout";

const QrCodeEditorWithId = withRestaurantId(QrCodeEditor);

const QrCodeManagementPage: React.FC = () => {
  const { t } = useTranslation();

  return <QrCodeEditorWithId />;
};

export default QrCodeManagementPage;
